import * as angular from 'angular';
import {
    BalancingAndPortfolioUploadWizardService,
    ShipperAssignmentPreSelection
} from 'app/_services/balancing-and-portfolio-upload-wizard.service';
import { mgoAngularWizard, PortfolioCodeUploadWizardContext } from '../custom';

class PortfolioCodeUploadWizardConfigurationComponentCtrl
    implements ng.IController
{
    public wizardCtrl: mgoAngularWizard.Wizard<PortfolioCodeUploadWizardContext>;
    public dragDropListener: { itemMoved: Function };
    public shippersWithRetiredAssignment: Array<Shipper>;
    public minRuntimeStart: Date;

    constructor(
        private $scope: ng.IScope,
        private balancingAndPortfolioUploadWizardService: BalancingAndPortfolioUploadWizardService
    ) {
        this.dragDropListener = {
            itemMoved: () =>
                (this.wizardCtrl.context.currentPortfolioCode.assignedShippers =
                    this.balancingAndPortfolioUploadWizardService.mapSelectedShippersToModel(
                        this.wizardCtrl.context.selectedShippers
                    ))
        };
        this.minRuntimeStart = new Date();
    }

    $onInit(): void {
        this.shippersWithRetiredAssignment = [];

        // race condition! shippersWithAssignmentToTso is not always loaded at this point
        if (this.wizardCtrl.context.shippersWithAssignmentToTso) {
            this.preSelectShipperAssignments();
        } else {
            this.$scope.$watch(
                () => this.wizardCtrl.context.shippersWithAssignmentToTso,
                (newValue, oldValue) => {
                    if (newValue && !oldValue) {
                        this.preSelectShipperAssignments();
                    }
                }
            );
        }

        this.wizardCtrl.context.currentPortfolioCode.validity =
            this.balancingAndPortfolioUploadWizardService.preSetValidity(
                this.wizardCtrl.context.currentPortfolioCode.validity,
                (this.wizardCtrl.context.currentPortfolioCode as any).$$exists
            );
    }

    private preSelectShipperAssignments(): void {
        if (!this.wizardCtrl.context.currentPortfolioCode.assignedShippers) {
            return;
        }

        const shipperAssignmentPreSelection: ShipperAssignmentPreSelection =
            this.balancingAndPortfolioUploadWizardService.preSelectShipperAssignments(
                this.wizardCtrl.context.currentPortfolioCode.assignedShippers,
                this.wizardCtrl.context.shippersWithAssignmentToTso
            );

        this.shippersWithRetiredAssignment =
            shipperAssignmentPreSelection.shippersWithRetiredAssignment;
        this.wizardCtrl.context.unselectedShippers =
            shipperAssignmentPreSelection.unselectedShippers;
        this.wizardCtrl.context.selectedShippers =
            shipperAssignmentPreSelection.selectedShippers;
        this.wizardCtrl.context.currentPortfolioCode.assignedShippers =
            this.balancingAndPortfolioUploadWizardService.mapSelectedShippersToModel(
                this.wizardCtrl.context.selectedShippers
            );
    }

    public submit(isValid): boolean {
        if (!isValid) {
            return false;
        }

        this.wizardCtrl.next();

        return true;
    }
}

angular.module('app').component('pkpPortfolioCodeUploadWizardConfiguration', {
    controller: PortfolioCodeUploadWizardConfigurationComponentCtrl,
    template:
        require('app/portfolio-code-upload-wizard/portfolio-code-upload-wizard-configuration.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
